import { render, staticRenderFns } from "./TopOffersAnimation.vue?vue&type=template&id=4b50491b&scoped=true&"
import script from "./TopOffersAnimation.vue?vue&type=script&lang=js&"
export * from "./TopOffersAnimation.vue?vue&type=script&lang=js&"
import style0 from "./TopOffersAnimation.vue?vue&type=style&index=0&id=4b50491b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b50491b",
  null
  
)

export default component.exports